import React, { useEffect } from "react";
import { useSEO } from "../../context/SEOContext";
import "./Contact.css";
import HeaderTarget from "../../components/HeaderTarget/HeaderTarget";
import FAQBtn from "../../components/FAQBtn/FAQBtn";
import { useTranslation } from "react-i18next";
const Contact = () => {
  const { t } = useTranslation();
  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: t("contact.meta.title"),
      description: t("contact.meta.description"),
      keywords: t("contact.meta.keywords"),
      favicon: "/faviconnew.png",
      ogUrl: "https://mukemel.com/contact",
    });
  }, [setSeo, t]);
  return (
    <>
      <HeaderTarget />
      <section className="bgcolorpage pt-5 pb-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-5 mb-4">
                  <FAQBtn />
                </div>
                <div className="col-lg-12">
                  <h3 className="fw-light">{t("ContactTitle")}</h3>
                  <p className="fw-light fw-14">{t("ContactIntro")}</p>
                </div>
              </div>
              <div className="bg-white">
                <div
                  className="row mb-5"
                  style={{ display: "flex", height: "100%" }}
                >
                  <div className="col-lg-4 p-5 d-flex flex-column">
                    <p className="text-uppercase fw-normal">
                      {t("CallUsTitle")}
                    </p>
                    <p className="fw-light fw-14">{t("CallUsDesc")}</p>
                    <p className="mb-2 fw-light fw-14">{t("CallUsHours")}</p>
                    <ul className="fw-light fw-14">
                      <li>{t("CallUsSchedule1")}</li>
                      <li>{t("CallUsSchedule2")}</li>
                    </ul>
                    <div className="mt-auto">
                      <a
                        href="tel:+905365049119"
                        className="text-decoration-none btn bgcolorfooterbottom w-100 p-3 fw-14 mb-3 mt-3"
                      >
                        <i className="fa-solid fa-mobile-screen mx-1"></i>
                        {t("CallButton")}
                      </a>
                    </div>
                  </div>

                  <div
                    className="col-lg-4 p-5 d-flex flex-column"
                    style={{ borderLeft: "1px solid #E1E1E1" }}
                  >
                    <p className="text-uppercase fw-normal">{t("ChatTitle")}</p>
                    <p className="fw-light fw-14">{t("ChatDesc")}</p>
                    <ul className="fw-light fw-14">
                      <li>{t("ChatHours")}</li>
                    </ul>
                    <p className="fw-light fw-14 mt-2">{t("ChatNote")}</p>

                    <div className="mt-auto">
                      <a
                        href="https://wa.me/905365049119"
                        className="text-decoration-none btn bgcolorfooterbottom w-100 p-3 fw-14 mb-3 mt-3"
                      >
                        <i className="fab fa-whatsapp mx-1 fa-lg"></i>
                        {t("ChatButton")}
                      </a>
                    </div>
                  </div>

                  <div
                    className="col-lg-4 p-5 d-flex flex-column"
                    style={{ borderLeft: "1px solid #E1E1E1" }}
                  >
                    <p className="text-uppercase fw-normal">
                      {t("EmailTitle")}
                    </p>
                    <p className="fw-light fw-14">{t("EmailDesc")}</p>
                    <div className="mt-auto">
                      <a
                        href="mailto:customer.support@mukemel.com"
                        className="text-decoration-none btn bgcolorfooterbottom w-100 p-3 fw-14 mb-3 mt-3"
                      >
                        <i className="fa-regular fa-envelope-open mx-1"></i>{" "}
                        {t("EmailButton")}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
